import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import _ from 'lodash'
import { Agendamento } from '@/types/core'
import TipoTabelaProcedimentoEnum from '@/types/enum/TipoTabelaProcedimentoEnum'
// eslint-disable-next-line
import {
  AgendamentoSolicitacaoItem,
  AgendamentoFiltro,
  AgendamentoCirurgia,
  Lembrete,
  StatusAvaliacaoPreAnestesia,
  NovaDataSolicitada,
  Convenio,
  Situacao,
  StatusCirurgiaEnum,
  Hospital,
  CentroCirurgico,
  // eslint-disable-next-line
} from '@/types/_'
import { getUser } from '@/utils/common'
import Apis from '@/Apis/_'
import { useConvenios, useHospitais } from '@/composables'

@Module({ namespaced: true, name: 'BackofficeFarmaciaStore' })
export default class BackofficeFarmaciaStore extends VuexModule {
  private agendamento: Agendamento.IAgendamento = new Agendamento.Agendamento()
  private novaDataSolicitadaDefault: NovaDataSolicitada = {
    dataAgendamento: null,
    dataAgendamentoVirtual: false,
    solicitacaoId: '',
    opcaoDataPrevisto1: '',
    opcaoDataPrevisto2: '',
    opcaoDataPrevisto3: '',
    opcao: 0,
    data: '',
    hora: '',
    alterarData: false,
    numeroAgendamento: '',
  }

  private lembreteDefault: Lembrete = {
    dataLembrete: null,
  }

  public lembrete: Lembrete = { ...this.lembreteDefault }

  public lembreteStatusFiltro: string = ''
  public deFiltro: Date | string | null = null
  public ateFiltro: Date | string | null = null
  public medicoId: string = ''
  public paciente: string = ''
  public medicosCadastrados: any = []
  public hospitaisFiltro: string[] = []
  public convenioFiltro: string[] = []
  public preAnestesiaFiltro: string = ''
  public opmeFiltro: string = ''
  public novaDataSolicitadaFiltro: boolean = false
  public dataPrevistaFiltro: boolean = false
  public dataVirtualFiltro: boolean = false
  public possuiItemParticular: boolean | null = null
  public primeiroTratamentoFiltro: boolean | null = null
  public origemFiltro: string | null = null
  public caraterFiltro: string | null = null
  public statusPrecificacaoOperadoraFiltro: string | null = null
  public cirurgiaRealizada: StatusCirurgiaEnum | null = null
  public numeroAgendamento: string = ''
  public ordenadoPorId: string = 'DataUltimaInteracaoAsc'
  public situacaoQuery: string = 'pendenteReserva'
  public statusAvaliacaoPreAnestesiaQuery: string[] = []
  public data: string[] = []
  public situacoes: string[] = ['pendenteReserva']
  public situacoesPendenciaAbertaFiltro: string[] = []
  public situacoesPendenciaAberta: Situacao[] = []
  public situacoesCounter: Situacao[] = []
  public ordenadoPor: any = [
    { id: 'DataUltimaInteracaoAsc', value: 'Tempo de ação mais antigo' },
    { id: 'DataUltimaInteracaoDesc', value: 'Tempo de ação mais recente' },
    { id: 'DataDoEnvioAsc', value: 'Data de envio mais antigo' },
    { id: 'DataDoEnvioDesc', value: 'Data de envio mais recente' },
    { id: 'AutorizacaoValidadeAsc', value: 'Data de validade mais antiga' },
    { id: 'AutorizacaoValidadeDesc', value: 'Data de validade mais recente' },
    { id: 'ProximasCirurgias', value: 'Próximas cirurgias' },
  ]

  get hospitais() {
    return useHospitais.hospitaisByCurrentUser
  }

  get convenios() {
    return useConvenios.conveniosByCurrentUser
  }


  public todosOsStatus: boolean = false
  public todosOsStatusDaArea: boolean = false

  public statusAvaliacaoPreAnestesia: StatusAvaliacaoPreAnestesia[] = []
  public preAnestesiaStatus: any[] = [
    { nome: 'Pendente', status: 'Pendente' },
    { nome: 'Apto', status: 'Apto' },
    { nome: 'Apto com atenção', status: 'AptoComAtencao' },
    { nome: 'Não apto', status: 'NaoApto' },
  ]

  public visualizarTriagem: boolean = false
  public novaDataSolicitada: NovaDataSolicitada = { ...this.novaDataSolicitadaDefault }
  public agendamentosCirurgia: AgendamentoCirurgia[] = []

  public filterOn: boolean = false
  public filterDrawer: boolean = false
  public solicitacoes: AgendamentoSolicitacaoItem[] = []

  private paginaDefault: number = 1
  private qtdPorPaginaDefault: number = 25

  public pagina: number = this.paginaDefault
  public qtdPorPagina: number = this.qtdPorPaginaDefault
  public totalSolicitacoes: number = 0
  public reservaUti: string[] = []
  public statusRoboAutorizacao: string[] = []
  public mapaCirurgicoStatus: string[] = []
  public tiposAcomodacao: string[] = []
  public sexo: string = ''
  public medicoSolicitanteEspecialidade: string[] = []
  public tecnicaDaCirurgia: string = ''
  public centrosCirurgico: CentroCirurgico[] = []
  public centroCirurgico: string = ''
  public tipoPeriodo: string = 'DataAgendamento'
  public procedimentoPrincipalTipoTabela: TipoTabelaProcedimentoEnum[] = []
  public procedimentoPrincipalIds: string[] = []

  @Mutation
  setTodosOsStatus(value: boolean) {
    if (value && !this.todosOsStatusDaArea) this.situacoes = []
    if (value && this.todosOsStatusDaArea) { this.todosOsStatusDaArea = false; this.situacoes = [] }
    if (!value) this.situacoes = ['pendenteReserva']
    this.todosOsStatus = value
  }

  @Mutation
  setTodosOsStatusDaArea(value: boolean) {
    if (value && !this.todosOsStatus) this.situacoes = []
    if (value && this.todosOsStatus) { this.todosOsStatus = false; this.situacoes = [] }
    if (!value) this.situacoes = ['pendenteReserva']
    this.todosOsStatusDaArea = value
  }

  @Mutation
  setTipoPeriodo(value: string) {
    this.tipoPeriodo = value
  }

  @Mutation
  setCentroCirurgico(value: any) {
    this.centroCirurgico = value
  }

  @Mutation
  setCentrosCirurgico(value: CentroCirurgico[]) {
    this.centrosCirurgico = value
  }

  @Mutation
  clearCentroCirurgico() {
    this.centroCirurgico = ''
  }

  @Mutation
  setReservaUti(value: string[]) {
    this.reservaUti = value
  }

  @Mutation
  setStatusRoboAutorizacao(value: string[]) {
    this.statusRoboAutorizacao = value
  }

  @Mutation
  setmapaCirurgicoStatus(value: string[]) {
    this.mapaCirurgicoStatus = value
  }

  @Mutation
  setTiposAcomodacao(value: string[]) {
    this.tiposAcomodacao = value
  }

  @Mutation
  setFilterDrawer(value: boolean) {
    this.filterDrawer = value
  }

  @Mutation
  setAgendamentoCirurgia(solicitacaoAlterada: any) {
    const index = this.solicitacoes.findIndex((e: any) => e.id === solicitacaoAlterada.solicitacaoId)
    if (![-1, undefined].includes(index)) {
      this.solicitacoes[index].convenioId = solicitacaoAlterada.convenioId
      this.solicitacoes[index].convenioNome = solicitacaoAlterada.convenioNome
      this.solicitacoes[index].hospitalId = solicitacaoAlterada.hospitalId
      this.solicitacoes[index].hospitalNome = solicitacaoAlterada.hospitalNome
      this.solicitacoes[index].carater = solicitacaoAlterada.carater
      this.solicitacoes[index].procedimentoPrincipalNome = solicitacaoAlterada.procedimentoPrincipalNome
    }
  }

  @Mutation
  setAgendamentos(solicitacoes: AgendamentoSolicitacaoItem[]) {
    const slct = solicitacoes.map((e: any) => {
      if (!e.lembreteStatus) e.lembreteStatus = ''
      if (!e.dataAgendamento) e.dataAgendamento = ''

      if (e.statusCirurgia) {
        e.cirurgiaRealizada = e.statusCirurgia === StatusCirurgiaEnum.Realizada
      }

      return e
    })
    this.solicitacoes = slct
  }

  @Mutation
  deleteSolicitacao(solicitacaoId: string) {
    const index = this.solicitacoes.findIndex(c => c.id === solicitacaoId)
    if (index >= 0) {
      this.solicitacoes.splice(index, 1)
    }
  }

  @Mutation
  setOrderBy(orderBy: string) {
    this.ordenadoPorId = orderBy
  }

  @Mutation
  setPaciente(paciente: string) {
    this.paciente = paciente
  }

  @Mutation
  setNovaDataSolicitadaFiltro(value: boolean) {
    this.novaDataSolicitadaFiltro = value
  }

  @Mutation
  setDataPrevistaFiltro(value: boolean) {
    this.dataPrevistaFiltro = value
  }

  @Mutation
  setConvenioFiltro(value: string[]) {
    this.convenioFiltro = value
  }

  @Mutation
  setHospitaisFiltro(value: string[]) {
    this.hospitaisFiltro = value
  }

  @Mutation
  setPreAnestesiaFiltro(value: string) {
    this.preAnestesiaFiltro = value
  }

  @Mutation
  setStatusPrecificacaoOperadora(value: string | null) {
    this.statusPrecificacaoOperadoraFiltro = value
  }

  @Mutation
  setOpmeFiltro(value: string) {
    this.opmeFiltro = value
  }

  @Mutation
  setDataVirtualFiltro(value: boolean) {
    this.dataVirtualFiltro = value
  }

  @Mutation
  setOrigemFiltro(value: string | null) {
    this.origemFiltro = value
  }

  @Mutation
  setCaraterFiltro(value: string | null) {
    this.caraterFiltro = value
  }

  @Mutation
  setCirurgiaRealizada(value: StatusCirurgiaEnum | null) {
    this.cirurgiaRealizada = value
  }

  @Mutation
  setDataAgendamentoVirtual(value: boolean) {
    this.dataVirtualFiltro = value
  }

  @Mutation
  setSalaVirtual(value: boolean) {
    this.novaDataSolicitada.dataAgendamentoVirtual = value
  }

  @Mutation
  setDataAgendamento(value: string) {
    this.novaDataSolicitada.dataAgendamento = value
  }

  @Mutation
  setMedicoAssistentes(medicos: any[]) {
    this.medicosCadastrados = medicos
  }

  @Mutation
  setMedicoId(value: string) {
    this.medicoId = value
  }

  @Mutation
  setNumeroAgendamento(value: string) {
    this.numeroAgendamento = value
  }

  @Mutation
  setNumeroReserva(value: string) {
    this.novaDataSolicitada.numeroAgendamento = value
  }

  @Mutation
  setOrdenadoPorId(value: string) {
    this.ordenadoPorId = value
  }

  @Mutation
  setStatusAvaliacaoPreAnestesia(value: StatusAvaliacaoPreAnestesia[]) {
    this.statusAvaliacaoPreAnestesia = value
  }

  @Mutation
  removeSituacoesPendenciaAbertaFiltro(value: string) {
    const index = this.situacoesPendenciaAbertaFiltro.indexOf(value)
    if (index >= 0) this.situacoesPendenciaAbertaFiltro.splice(index, 1)
  }

  @Mutation
  removeConvenioFiltro(value: string) {
    const index = this.convenioFiltro.indexOf(value)
    if (index >= 0) this.convenioFiltro.splice(index, 1)
  }

  @Mutation
  removeReservaUti(value: any) {
    const index = this.reservaUti.indexOf(value)
    if (index >= 0) this.reservaUti.splice(index, 1)
  }

  @Mutation
  removeStatusRoboAutorizacao(value: string) {
    const index = this.statusRoboAutorizacao.indexOf(value)
    if (index >= 0) this.statusRoboAutorizacao.splice(index, 1)
  }

  @Mutation
  removeMapaCirurgicoStatus(value: any) {
    const index = this.mapaCirurgicoStatus.indexOf(value)
    if (index >= 0) this.mapaCirurgicoStatus.splice(index, 1)
  }

  @Mutation
  removeTipoAcomodacao(value: string) {
    const index = this.tiposAcomodacao.indexOf(value)
    if (index >= 0) this.tiposAcomodacao.splice(index, 1)
  }

  @Mutation
  removeHospitaisFiltro(value: string) {
    const index = this.hospitaisFiltro.indexOf(value)
    if (index >= 0) this.hospitaisFiltro.splice(index, 1)
  }

  @Mutation
  setPossuiItemParticular(value: boolean | null) {
    this.possuiItemParticular = value
  }

  @Mutation
  setPrimeiroTratamentoFiltro(value: boolean | null) {
    this.primeiroTratamentoFiltro = value
  }

  @Mutation
  setData(value: string) {
    if (this.data.includes(value)) return
    this.data.push(value)
  }

  @Mutation
  setStatusAvaliacaoPreAnestesiaQuery(value: string) {
    this.statusAvaliacaoPreAnestesiaQuery.push(value)
  }

  @Mutation
  removeStatusAvaliacaoPreAnestesiaQuery(value: string) {
    const removeArray: any[] = []

    for (let i = 0; i < this.statusAvaliacaoPreAnestesiaQuery.length; i++) {
      if (this.statusAvaliacaoPreAnestesiaQuery[i] === value) removeArray.push(i)
    }

    for (let i = 0; i < removeArray.length; i++) {
      this.statusAvaliacaoPreAnestesiaQuery.splice(removeArray[i], 1)
    }
  }

  @Mutation
  setSituacoes(value: string) {
    if (this.situacoes.includes(value)) {
      this.situacoes.splice(this.situacoes.indexOf(value), 1)
    } else {
      this.situacoes.push(value)
    }
  }

  @Mutation
  setSituacoesPendenciaAbertaFiltro(value: string[]) {
    this.situacoesPendenciaAbertaFiltro = value
  }

  @Mutation
  setSituacoesPendenciaAberta(value: Situacao[]) {
    this.situacoesPendenciaAberta = value
  }

  @Mutation
  resetSituacoes() {
    this.situacoes = ['pendenteReserva']
  }

  @Mutation
  fillAllSituacoes() {
    this.situacoes = [
      'pendenteReserva',
      'pendenteAjusteData',
      'pendenteAjusteMaterial',
      'pendenteCancelamento',
      'concluido',
    ]
  }

  @Mutation
  clearSituacoes() {
    this.situacoes = []
  }

  @Mutation
  setSituacoesCounter(value: Situacao[]) {
    this.situacoesCounter = value
  }

  @Mutation
  removeData(value: string) {
    const index = this.data.indexOf(value)
    if (index >= 0) this.data.splice(index, 1)
  }

  @Mutation
  clearHospitaisFiltro() {
    this.hospitaisFiltro = []
  }

  @Mutation
  clearConvenioFiltro() {
    this.convenioFiltro = []
  }

  @Mutation
  clearPreAnestesiaFiltro() {
    this.preAnestesiaFiltro = ''
  }

  @Mutation
  clearAgendamentosCirurgia() {
    this.agendamentosCirurgia = []
  }

  @Mutation
  setFilterOn(value: boolean) {
    this.filterOn = value
  }

  @Mutation
  setPagina(value: number) {
    this.pagina = value
  }

  @Mutation
  setQtdPorPagina(value: number) {
    this.qtdPorPagina = value
  }

  @Mutation
  setTotalSolicitacoes(value: number) {
    this.totalSolicitacoes = value
  }

  @Mutation
  clearFiltro() {
    this.ordenadoPorId = 'DataUltimaInteracaoAsc'
    this.paciente = ''
    this.medicoId = ''
    this.numeroAgendamento = ''
    this.novaDataSolicitadaFiltro = false
    this.dataPrevistaFiltro = false
    this.novaDataSolicitada = { ...this.novaDataSolicitadaDefault }
    this.dataVirtualFiltro = false
    this.origemFiltro = null
    this.caraterFiltro = null
    this.statusPrecificacaoOperadoraFiltro = null
    this.convenioFiltro = []
    this.possuiItemParticular = null
    this.primeiroTratamentoFiltro = null
    this.hospitaisFiltro = []
    this.preAnestesiaFiltro = ''
    this.opmeFiltro = ''
    this.lembreteStatusFiltro = ''
    this.deFiltro = null
    this.ateFiltro = null
    this.statusAvaliacaoPreAnestesiaQuery = []
    this.cirurgiaRealizada = null
    this.data = []
    this.medicoSolicitanteEspecialidade = []
    this.tecnicaDaCirurgia = ''
    this.centroCirurgico = ''
    this.tipoPeriodo = 'DataAgendamento'
    this.situacoesPendenciaAbertaFiltro = []
    this.procedimentoPrincipalTipoTabela = []
    this.procedimentoPrincipalIds = []
  }

  @Mutation
  clearPagePagination() {
    this.pagina = this.paginaDefault
    this.qtdPorPagina = this.qtdPorPaginaDefault
  }

  @Mutation
  setDataConfirmadaAgendamento(params: any) {
    this.solicitacoes.map((c) => {
      const t = c
      if (t.id === params.solicitacaoId) {
        t.dataAgendamento = params.dataAgendamento
        t.acoes.confirmarData = params.confirmarData
        t.acoes.alterarData = params.alterarData
        t.numeroAgendamento = params.numeroAgendamento
        t.dataAgendamentoVirtual = params.dataAgendamentoVirtual
      }
      return t
    })
  }

  @Mutation
  setLembreteStatus(params: any) {
    const solicitacao = this.solicitacoes.find((e: any) => e.id === params.solicitacaoId)
    const solicitacaoIndex = this.solicitacoes.findIndex((e: any) => e.id === params.solicitacaoId)
    // @ts-ignore
    solicitacao.lembreteStatus = params.concluido ? '' : 'Normal'
    // @ts-ignore
    this.solicitacoes[solicitacaoIndex] = solicitacao
  }

  @Mutation
  setLembreteStatusFiltro(value: string) {
    this.lembreteStatusFiltro = value
  }

  @Mutation
  setSexo(value: string) {
    this.sexo = value
  }

  @Mutation
  setMedicoSolicitanteEspecialidade(value: string[]) {
    this.medicoSolicitanteEspecialidade = value
  }

  @Mutation
  setTecnicaDaCirurgia(value: string) {
    this.tecnicaDaCirurgia = value
  }

  @Mutation
  setDeFiltro(value: Date | string | null) {
    this.deFiltro = value
  }

  @Mutation
  setAteFiltro(value: Date | string | null) {
    this.ateFiltro = value
  }

  @Mutation
  setProcedimentoPrincipalTipoTabela(value: TipoTabelaProcedimentoEnum[]) {
    this.procedimentoPrincipalTipoTabela = value
  }

  @Mutation
  setProcedimentoPrincipalIds(value: string[]) {
    this.procedimentoPrincipalIds = value
  }

  @Action
  async loadAgendamentosMedicoSearch(solicitacaoId: string = '') {
    const queryString: AgendamentoFiltro = {
      situacao: this.situacoes,
      statusAvaliacaoPreAnestesiaQuery: this.statusAvaliacaoPreAnestesiaQuery,
      data: this.data,
      convenioNome: this.convenioFiltro,
      hospitalId: this.hospitaisFiltro,
      dataAgendamentoVirtual: this.dataVirtualFiltro,
      origemDaSolicitacao: this.origemFiltro,
      carater: this.caraterFiltro,
      statusPrecificacaoOperadora: this.statusPrecificacaoOperadoraFiltro,
      etapa: 'Farmacia',
      possuiItemParticular: this.possuiItemParticular,
      primeiroTratamento: this.primeiroTratamentoFiltro,
      medicoId: this.medicoId,
      numeroAgendamento: this.numeroAgendamento,
      opme: this.opmeFiltro,
      orderBy: this.ordenadoPorId,
      paciente: this.paciente,
      pagina: this.pagina,
      preanestesia: this.preAnestesiaFiltro,
      qtdPorPagina: this.qtdPorPagina,
      usuarioId: getUser().profile.sub,
      lembreteStatus: this.lembreteStatusFiltro,
      de: this.deFiltro,
      ate: this.ateFiltro,
      medicoSolicitanteEspecialidade: this.medicoSolicitanteEspecialidade,
      tecnicaDaCirurgia: this.tecnicaDaCirurgia,
      statusCirurgia: this.cirurgiaRealizada,
      centroCirurgico: this.centroCirurgico,
      todosOsStatus: this.todosOsStatus,
      solicitacaoId,
      tipoPeriodo: this.tipoPeriodo,
      situacaoPendenciaAberta: this.situacoesPendenciaAbertaFiltro,
      procedimentoPrincipalTipoTabela: this.procedimentoPrincipalTipoTabela,
      procedimentoPrincipalIds: this.procedimentoPrincipalIds,
    }
    const response = await this.agendamento.getAllSearch(queryString)

    if (response.success) {
      this.context.commit('setAgendamentos', response.data.solicitacoes)
      this.context.commit('setSituacoesCounter', response.data.statusSituacaoFarmacia)
      this.context.commit('setTotalSolicitacoes', response.data.totalSolicitacoes)
      this.context.commit('setStatusAvaliacaoPreAnestesia', response.data.statusAvaliacaoPreAnestesia)
      this.context.commit('setSituacoesPendenciaAberta', response.data.situacoesPendenciaAberta)
    }

    return response
  }

  @Action
  async getAllConvenios() {
    await useConvenios.loadConveniosByCurrentUser()
  }

  @Action
  async getAllHospitais() {
    await useHospitais.loadHospitaisByCurrentUser()
  }

  @Action
  async backofficeVoltaStatus(params: any) {
    const request = await this.agendamento.backofficeVoltaStatus(params)
    if (request.success) {
      await this.context.dispatch('loadAgendamentosMedicoSearch')
    }
    return request
  }

  @Action
  async getCentroCirurgicoByHospitalId(params: any) {
    const { hospitalIds } = params
    if (hospitalIds && hospitalIds.length <= 0) {
      this.context.commit('setCentrosCirurgico', [])
      this.context.commit('clearCentroCirurgico')
      return null
    }

    const request = await this.agendamento.getCentroCirurgico(params)
    if (request.success) {
      request.data.map((c) => {
        const temp = c
        temp.nome = `${c.hospital.nome} - ${c.nome}`
        return temp
      })

      this.context.commit('setCentrosCirurgico', request.data)
    }
    return request
  }

  @Action
  async backofficeFinalizaSolicitacaoNaFarmacia(params: any) {
    try {
      const request = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.backofficeFinalizaSolicitacaoNaFarmacia({
        solicitacaoId: params.id,
        statusSituacaoFarmacia: params.statusSituacaoFarmacia,
      })
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  init() {
    this.context.dispatch('getAllHospitais')
    this.context.dispatch('getAllConvenios')
  }
}
